import React from "react";
import "./Sidebar.scss";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ToggleSidebar } from "../../Redux/Toggles/Toggles.actions";

const Sidebar = (props) => {
  const show = useSelector((state) => state.toggles.sidebar);
  const dispatch = useDispatch();

  const toggle = () => {
    document.getElementsByClassName("Sidebar")[0].classList.add("hide");

    setTimeout(() => {
      dispatch(ToggleSidebar());
    }, 450);
  };

  return (
    <>
      {show ? (
        <div className="Sidebar">
          <div className="side-options">
            <NavLink
              onClick={toggle}
              to="/catagories"
              className="link"
              activeClassName="active"
            >
              Catagories
            </NavLink>
            <NavLink
              onClick={toggle}
              activeClassName="active"
              to="/about"
              className="link"
            >
              About Us
            </NavLink>
            <NavLink
              onClick={toggle}
              activeClassName="active"
              to="/contact"
              className="link"
            >
              Contact
            </NavLink>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Sidebar;
